import { render, staticRenderFns } from "./ReporteSexo.vue?vue&type=template&id=222c9a5a"
import script from "./ReporteSexo.vue?vue&type=script&lang=js"
export * from "./ReporteSexo.vue?vue&type=script&lang=js"
import style0 from "./ReporteSexo.vue?vue&type=style&index=0&id=222c9a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports